// Lives in its own file (not inline in gprsFeature.ts) so the route factory
// can import it without a circular import back through gprsFeature.ts ->
// presentation/routes -> here.
//
// Irregular: the backend grants only create and view for GPRS -- no update
// or delete.
const GPRS_MANAGEMENT = "core.gprs_management";
const GPRS_MANAGEMENT_LIST = `${GPRS_MANAGEMENT}.gprs_management_list`;

export const GPRS_VIEW = `${GPRS_MANAGEMENT_LIST}.view`;
export const GPRS_CREATE = `${GPRS_MANAGEMENT_LIST}.create`;
